import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-adm-fee-students',
  templateUrl: './adm-fee-students.component.html',
  styleUrls: ['./adm-fee-students.component.scss']
})
export class AdmFeeStudentsComponent implements OnInit {
  APIService: any;
  studentGrid: any;
  constructor(
    public umsService: UmsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router, 
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.studentGrid = this.data.data
  }

}
